import { memo } from 'react';
import { HStack, Text } from '@library';
import usePriceFormatter from '../../../../core/hooks/usePriceFormatter';
import type { ProductCustomerPrice } from '../../../types';
import ProductPriceDiscountTag from '../../ProductTileView/ProductPriceDiscountTag';
import styles from './ProductRowDiscounts.module.css';

const ProductRowDiscounts = ({
    customerPrice,
    showInlineDiscount,
    onSale = false,
}: {
    customerPrice?: ProductCustomerPrice;
    showInlineDiscount?: boolean;
    onSale?: boolean;
}) => {
    const priceFormatter = usePriceFormatter();

    if (!showInlineDiscount || !customerPrice) {
        return null;
    }

    const formattedGeneralPrice = priceFormatter(
        customerPrice.generalDealerPrice
    );

    return (
        <div className={styles.productDiscounts}>
            <div className={styles.discountSection}>
                <HStack align="center">
                    <ProductPriceDiscountTag
                        customerPrice={customerPrice}
                        onSale={onSale}
                    />

                    {(customerPrice.dealerDiscountPercentage || 0) > 0 ? (
                        <div className={styles.netDealerPrice}>
                            <Text secondary bold strikeThrough>
                                {formattedGeneralPrice.price}
                            </Text>
                        </div>
                    ) : null}
                </HStack>
            </div>
        </div>
    );
};

export default memo(ProductRowDiscounts);
